<template>
  <v-container class="v-container">
    <v-layout justify-center align-center>
      <v-flex xs12 sm10 md5 lg5>
        <div class="page-title">Registration</div>
        <div class="registration-form">
        <v-form v-if="!successfullRegisterText" method="post" @submit.prevent="validate">
          <v-layout column class="login-layout">
            <v-flex xs12 sm10 md8 lg4>
              <input
                v-model="form.email"
                @input="clearRecaptcha"
                :class="{
                  'wrong-input': $v.form.email.$invalid && showErrors,
                }"
                type="email"
                placeholder="Email"
                id="email-registration"
                class="custom-input"
              />
            </v-flex>
            <p v-if="showErrors" class="error-message">
              <span v-if="!$v.form.email.required">Email is required.</span>
              <span v-if="!$v.form.email.email">The input must be a proper email!</span>
            </p>
            <div class="recaptch">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="sitekey"
                @verify="verifyRecaptcha"
                @expired="onCaptchaExpired"
              />
            </div>
            <span style="margin-top: 10px" class="error-message" v-if="!recaptchaToken"
              >You must fill in reCAPTCHa field!</span
            >
            <v-flex xs12 sm12 md12 class="submit-button-container">
              <button class="submit-button" @click="submit" type="submit" id="submit-registration">
                Submit
              </button>
            </v-flex>
            <router-link :to="{ name: 'login' }"
              ><div class="registration">
                <span>Login</span>
              </div></router-link
            >
          </v-layout>
        </v-form>
        <div v-else class="register-text">
          {{ successfullRegisterText }}
          <strong style="color: #536f51c4">{{ form.email }}</strong>
        </div>
        <v-flex xs12 sm12 md12 v-if="successfullRegisterText" class="submit-button-container">
          <router-link :to="{ name: 'login' }">
            <button class="submit-button">Login</button>
          </router-link>
        </v-flex>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthorizService from '@/services/AuthorizService';
import VueRecaptcha from 'vue-recaptcha';
import { required, email } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
export default {
  components: { VueRecaptcha },
  data() {
    return {
      form: {
        username: '',
        password: '',
        repeatPassword: '',
        email: '',
      },
      sitekey: '6LeYucMUAAAAANUhylR9jQyuGvO5e53L4q5mJHcK',
      showErrors: false,
      successfullRegisterText: '',
      recaptchaToken: '',
    };
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar']),
    validate() {
      this.showErrors = false;
      if (this.$v.$invalid) {
        this.showErrors = true;
      }
    },
    clearRecaptcha() {
      this.showErrors = false;
      if (this.$v.$invalid) {
        this.showErrors = true;
      }
    },
    verifyRecaptcha(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    submit() {
      this.showErrors = false;
      if (!this.$v.$invalid && this.recaptchaToken) {
        this.setLoading({ show: true, text: 'Registering...' });
        let jsonToSend = {
          email: this.form.email.toLowerCase(),
          'g-recaptcha-response': this.recaptchaToken,
        };
        AuthorizService.registrateProfile(jsonToSend)
          .then((response) => {
            this.$refs.recaptcha.reset();
            this.recaptchaToken = '';
            this.successfullRegisterText = '';
            this.setLoading({ show: false, text: '' });
            if (response.data === 'User was created. Wait password and broker key by email.') {
              this.successfullRegisterText = `You are successfully registered. Your username and password have been sent to`;
              this.showSnackbar(`${this.successfullRegisterText} ${this.form.email}`);
            }
          })
          .catch((error) => {
            this.$refs.recaptcha.reset();
            this.recaptchaToken = '';
            this.setLoading({ show: false, text: '' });
            console.log(error, 'response');
            if (error.response.data.email) {
              this.showSnackbar(error.response.data.email[0]);
            } else {
              this.showSnackbar(error.response.data);
            }
          });
      } else {
        this.showErrors = true;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.recaptchaToken = '';
    },
  },
  validations: {
    form: {
      email: {
        email,
        required,
      },
    },
  },
};
</script>

<style scoped>
.submit-button-container {
  margin-top: 30px;
}
.v-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  justify-content: center;
  align-items: center;
}
.user-form {
  margin: auto;
}
.submit-button {
  margin-top: 0;
}
.registration-form {
  position: relative;
  -webkit-box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  background-color: #ffffff;
  margin-right: auto;
  margin-left: auto;
  padding: 46px 35px;
}

.register-text {
  color: #216169;
  font-size: 16px;
  font-weight: 500;
}

.error-message {
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #fd6262;
}

.error-message span {
  display: block;
}

.wrong-input {
  outline: 2px solid #fd6262 !important;
}

.registration-form {
  max-width: 450px;
}
.registration {
  
  margin-top: 14px;
  color: #216169;
  display: flex;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  flex-direction: row;
  justify-content: center;
  text-decoration: underline;
}
.custom-input {
  background-position-y: center;
  background-position-x: 10px;
  width: 100%;
  height: 46px;
  color: #216169;
  background-color: #c4c4c44d;
  font-size: 12px;
  margin-bottom: 17px;
  padding: 10px 10px 10px 50px;
}
.custom-input[type='text'] {
  background-repeat: no-repeat;
  background-image: url('../assets/user.png');
}
.custom-input[type='email'] {
  background-repeat: no-repeat;
  background-image: url('../assets/Vector_Smart_Object(1).png');
}
.custom-input[type='password'] {
  background-repeat: no-repeat;
  background-image: url('../assets/password.png');
}
</style>
